// extracted by mini-css-extract-plugin
module.exports = {"title":"dZFFMuJF0ADL4me2LtLt"};